import { Component, OnInit } from '@angular/core';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
//import * as moment from 'moment';
import moment from 'moment';
import { SpecialEnrollmentCircumstance } from 'src/app/angular-elements/shared/interfaces/special-enrollment-circumstances.interface';
import { GetOpenEnrollmentRule } from '../../family-form/types/qualifying-life-event.response.interface';

@FormComponentLookup('special-enrollment-event-info')
@Component({
    selector: 'app-special-enrollment-event-info',
    templateUrl: './special-enrollment-event-info.component.html',
    styleUrls: ['./special-enrollment-event-info.component.scss'],
    standalone: false
})
export class SpecialEnrollmentEventInfoComponent
 extends FormEntryComponentClass
 implements OnInit {

  effectiveDate: string;
  lifeEvent: string;
  sepReason: string;
  lifeEventDate: string;

  constructor() {
    super();
  }
  

  ngOnInit(): void {
    
    /** Effective Date stuff */
    const payloadStates = this.reducerUtilityService.getPayloadStates();
    const effectiveDateState: {
      effectiveDate: string
    } = payloadStates.individualMarket.ratingInfo;
    this.effectiveDate = moment.utc(effectiveDateState.effectiveDate).format('MM/DD/YYYY');

    /** SEP Event stuff */
    const specialEnrollmentState: SpecialEnrollmentCircumstance = payloadStates['special-enrollment-circumstance'];

    if (specialEnrollmentState) {
      this.lifeEventDate = specialEnrollmentState.dateOfLifeEvent ? moment.utc(specialEnrollmentState.dateOfLifeEvent).format('MM/DD/YYYY') : null;
      this.lifeEvent = specialEnrollmentState.lifeEvent.lifeEventDescription;
      this.sepReason = this.reducerUtilityService.getGlobalStateItem('payloadStates.special-enrollment-circumstance.eventReason.label')
    }

    console.log(
      `SEP Event Info Display:\n
        Life Event Date: ${this.lifeEventDate}\n
        Life Event Description: ${this.lifeEvent}\n
        SEP Event Reason Label: ${this.sepReason}\n
        Effective Date to Display: ${this.effectiveDate}`
    );
  }
}
